import {AppStore} from "../../desktop";
import {Contract} from "../../models/Contract";
import {ContractsActionTypes} from "./types";
import {actionSetTabItem} from "../tabs/actions";
import {TabsActionTypes} from "../tabs";

export const actionContractFetchAll = () => {
	AppStore.dispatch({type: ContractsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionContractFetchAllCompleted = (contracts: Contract[]) => {
	AppStore.dispatch({type: ContractsActionTypes.FETCH_ALL_COMPLETED, payload: contracts})
}

export const actionContractFetch = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.FETCH_ONE_REQUEST, payload: contract})
}

export const actionContractFetchCompleted = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.FETCH_ONE_COMPLETED, payload: contract})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: contract})
}

export const actionContractSave = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.SAVE_REQUEST, payload: contract})
}

export const actionContractSaveCompleted = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.SAVE_COMPLETED, payload: contract})
}

export const actionContractDelete = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.DELETE_REQUEST, payload: contract})
}

export const actionContractDeleteCompleted = (contract: Contract) => {
	AppStore.dispatch({type: ContractsActionTypes.DELETE_COMPLETED, payload: contract})
}

export const actionDeleteContracts = (contracts: Contract[]) => {
	AppStore.dispatch({type: ContractsActionTypes.DELETE_MULTIPLE_REQUEST, payload: contracts})
}

export const actionDeleteContractsCompleted = (contracts: Contract[]) => {
	AppStore.dispatch({type: ContractsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: contracts})
}
